import axios from 'axios';

export const whatsappApi = axios.create({
    baseURL: `${process.env.REACT_APP_BACKEND!}api/whatsapp`,
    headers: {
        'Content-Type': 'application/json'
    }
})